import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexRow } from "@similarweb/ui-components";

export const ApplyButton = styled(FlexRow)`
    width: 100%;
    height: 40px;
    border-radius: 0 0 2px 2px;
    background: ${colorsPalettes.blue[400]};
    ${setFontVariant("button", colorsPalettes.carbon[0])};
    padding-right: 20px;
    justify-content: end;
    align-items: center;
    box-sizing: border-box;
    cursor: pointer;
`;

ApplyButton.displayName = "ApplyButton";

export const PixelButton = styled.div`
    width: 1px;
    height: 1px;
    opacity: 0;
    pointer-events: none;
`;

PixelButton.displayName = "PixelButton";
